__turbopack_context__.v({
  "Pagination": "ftdk9W_Pagination",
  "Pagination__Item": "ftdk9W_Pagination__Item",
  "Pagination__Item--Disabled": "ftdk9W_Pagination__Item--Disabled",
  "Pagination__Link": "ftdk9W_Pagination__Link",
  "Pagination__Link--Active": "ftdk9W_Pagination__Link--Active",
  "Pagination__Link--Chevron": "ftdk9W_Pagination__Link--Chevron",
  "Pagination__Link--ChevronLeft": "ftdk9W_Pagination__Link--ChevronLeft",
  "Pagination__Link--ChevronRight": "ftdk9W_Pagination__Link--ChevronRight",
  "Pagination__Link--Disabled": "ftdk9W_Pagination__Link--Disabled",
  "Pagination__List": "ftdk9W_Pagination__List",
});
